module.exports = __webpack_public_path__ + "img/home-1-small.bfdceb5f.png";